const CONDITION = {
  new: 'Nuevo',
  used: 'Usado'
}

export function getCondition (condition) {
  return CONDITION[condition] ? CONDITION[condition] : condition
}
